export default __webpack_public_path__ + "42eeba44a6e52bf8067d665e671ff361.webp";